var _rect, _rect2, _rect3, _rect4, _path, _path2, _path3, _path4, _g, _path5, _path6, _path7, _path8, _path9, _g2, _path10, _path11, _path12, _g3, _path13, _g4, _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg403(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 160,
    viewBox: "0 0 300 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 85,
    width: 5,
    height: 75,
    fill: "#ACEBFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 253,
    y: 158,
    width: 2,
    height: 21,
    transform: "rotate(90 253 158)",
    fill: "#ACEBFF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 85,
    width: 5,
    height: 75,
    fill: "#ACEBFF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 158,
    width: 2,
    height: 21,
    transform: "rotate(90 68 158)",
    fill: "#ACEBFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 120H250V137H50V120Z",
    fill: "#ACEBFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50 92H250V109H50V92Z",
    fill: "#ACEBFF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_768_3290",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 50,
    y: 92,
    width: 200,
    height: 45
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50 120H250V137H50V120Z",
    fill: "#ACEBFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50 92H250V109H50V92Z",
    fill: "#ACEBFF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_768_3290)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.1718 74H72.6853L32.6853 145.24H15.1718L55.1718 74Z",
    fill: "#F0FBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.6852 74H106.199L66.1987 145.24H48.6852L88.6852 74Z",
    fill: "#F0FBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.199 74H139.712L99.7122 145.24H82.1987L122.199 74Z",
    fill: "#F0FBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.712 74H173.226L133.226 145.24H115.712L155.712 74Z",
    fill: "#F0FBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.226 74H206.739L166.739 145.24H149.226L189.226 74Z",
    fill: "#F0FBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.739 74H240.253L200.253 145.24H182.739L222.739 74Z",
    fill: "#F0FBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.253 74H273.766L233.766 145.24H216.253L256.253 74Z",
    fill: "#F0FBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.766 74H307.28L267.28 145.24H249.766L289.766 74Z",
    fill: "#F0FBFF"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M224.5 159.668C207.5 150.212 203.714 135.629 201.974 121.136C201.392 116.275 200.886 111.402 200.215 106.554C199.203 99.1485 196.324 75.3749 192.247 68.9432C188.589 63.1584 182.272 60.3482 175.5 60.5001C170.842 60.6014 166.791 62.247 162.956 64.766C159.386 67.1077 155.69 69.7786 151.259 69.9938C146.462 70.2217 144.589 68.0191 140.778 65.4368C137.652 63.3229 134.234 61.2596 130.5 60.5001C126.968 59.7786 123.222 60.1457 119.854 61.4495C116.513 62.7406 113.551 64.9305 111.171 67.6141C105.378 74.159 103.159 97.8482 102.342 106.2C100.417 125.714 92 151.212 76 159.681H224.5V159.668Z",
    fill: "url(#paint0_linear_768_3290)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M198.5 120.5C198.5 134.386 195.323 147.162 189.373 147.402C185.918 147.554 181.652 146.326 176.778 144.795C169.386 142.478 160.601 139.453 151.184 139.453C142.715 139.453 134.766 141.896 127.88 144.073C123.133 145.567 118.892 146.947 115.335 147.314C107.968 148.086 104 136.12 104 120.5C104 94.0533 107.968 85.8164 115.335 86.3227C118.905 86.5506 123.158 87.8037 127.918 89.1835C134.804 91.1962 142.741 93.5 151.184 93.5C160.601 93.5 169.386 90.6265 176.778 88.5126C181.652 87.1075 185.918 86.0316 189.373 86.3227C195.335 86.8038 198.5 106.614 198.5 120.5Z",
    fill: "#030D69"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M127.829 144.187C123.082 145.681 118.842 147.06 115.285 147.428V144.731C115.285 141.314 118.069 138.529 121.513 138.529H121.652C124.892 138.529 127.563 141.022 127.829 144.187Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M189.322 144.731V147.516C185.867 147.668 181.601 146.44 176.728 144.909V144.731C176.728 141.314 179.525 138.529 182.943 138.529H183.107C186.538 138.529 189.322 141.314 189.322 144.731Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_768_3290",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 104,
    y: 86,
    width: 95,
    height: 62
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M198.5 120.5C198.5 134.386 195.323 147.162 189.373 147.402C185.918 147.554 181.652 146.326 176.778 144.795C169.386 142.478 160.601 139.453 151.184 139.453C142.715 139.453 134.766 141.896 127.88 144.073C123.133 145.567 118.892 146.947 115.335 147.314C107.968 148.086 104 136.12 104 120.5C104 94.0533 107.968 85.8164 115.335 86.3227C118.905 86.5506 123.158 87.8037 127.918 89.1835C134.804 91.1962 142.741 93.5 151.184 93.5C160.601 93.5 169.386 90.6265 176.778 88.5126C181.652 87.1075 185.918 86.0316 189.373 86.3227C195.335 86.8038 198.5 106.614 198.5 120.5Z",
    fill: "#030D69"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_768_3290)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 112.93,
    y: 79.2237,
    width: 79.3741,
    height: 79.3741,
    rx: 39.6871,
    fill: "#40E0D0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.965,
    y: 83.2589,
    width: 71.3037,
    height: 71.3037,
    rx: 35.6518,
    fill: "#40E0D0",
    stroke: "white",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.036,
    y: 110.77,
    width: 67.1627,
    height: 16.2819,
    fill: "white"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M178.5 84.5C188.5 81.5588 191.519 82.2726 192 76.5C192 67.538 184.703 62.9995 175.741 62.9995C166.778 62.9995 159.5 70.2653 159.5 79.2274C159.5 88.1894 168.5 87.4412 178.5 84.5Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M125 84.5C115 81.5588 111.981 82.2726 111.5 76.5C111.5 67.538 118.797 62.9995 127.759 62.9995C136.722 62.9995 144 70.2653 144 79.2274C144 88.1894 135 87.4412 125 84.5Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_768_3290",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 159,
    y: 62,
    width: 33,
    height: 25
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M178.5 84.5C188.5 81.5588 191.519 82.2726 192 76.5C192 67.538 184.703 62.9995 175.741 62.9995C166.778 62.9995 159.5 70.2653 159.5 79.2274C159.5 88.1894 168.5 87.4412 178.5 84.5Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_768_3290)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168 89C170.481 89 172.5 86.981 172.5 84.5C172.5 82.019 170.481 80 168 80C165.519 80 163.5 82.019 163.5 84.5C163.5 86.981 165.519 89 168 89Z",
    fill: "#2F6CDA"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_768_3290",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 111,
    y: 62,
    width: 33,
    height: 25
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M125 84.5C115 81.5588 111.981 82.2726 111.5 76.5C111.5 67.538 118.797 62.9995 127.759 62.9995C136.722 62.9995 144 70.2653 144 79.2274C144 88.1894 135 87.4412 125 84.5Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_768_3290)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.5 89C133.019 89 131 86.981 131 84.5C131 82.019 133.019 80 135.5 80C137.981 80 140 82.019 140 84.5C140 86.981 137.981 89 135.5 89Z",
    fill: "#2F6CDA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_768_3290",
    x1: 148.493,
    y1: 156.467,
    x2: 142.519,
    y2: 78.7831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E64E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7AB5F3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg403);
export default __webpack_public_path__ + "static/media/403.ccca696ff735dec1f2e5f25d9d98029e.svg";
export { ForwardRef as ReactComponent };